import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypePostSalesChannelParams, TypePostSalesChannelResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/third-parties/sales-channel';

/**
 * [상품관리][상품 판매처 매핑] 상품 판매처 등록 API
 */
export const fetchPostSalesChannel = async (params: TypePostSalesChannelParams) => {
  const { data } = await axiosInstance.post<TypePostSalesChannelResponse>(ENDPOINT, { ...params });
  return data.data;
};

/**
 * [상품관리][상품 판매처 매핑] 상품 판매처 등록 Mutation Hook
 */
export const usePostSalesChannelMutation = () => {
  return useMutation({
    mutationFn: fetchPostSalesChannel,
  });
};
